export const GET_SUBSCRIPTION_PLANS = "GET_SUBSCRIPTION_PLANS";
export const CREATE_STRIPE_PAYMENT = "CREATE_STRIPE_PAYMENT";
export const CANCEL_SUBSCRIPTION_PLAN = "CANCEL_SUBSCRIPTION_PLAN";
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
